// extracted by mini-css-extract-plugin
export default {"inputs":"MediaForm_inputs__i23-L","actions":"MediaForm_actions__9vlXg","dropzone":"MediaForm_dropzone__JYDzr","fileWrapper":"MediaForm_fileWrapper__afC+t"};